function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.94 8.56l-8-8a2 2 0 00-2.84 2.93L16.66 8H2a2 2 0 000 4.08h14.48l-4.38 4.43A2 2 0 1015 19.4l8-8a2 2 0 00-.06-2.84z",
  fill: "#231f20"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.54 20"
  }, props), _ref);
};

export default SvgComponent;